// TODO: Use global theming instead of hardcoding pixel values
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  // how do we put title in the theme?
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
  },
  grid: {
    cursor: 'pointer',
  },
  popover: {
    padding: theme.spacing(2),
  },
  popoverHeader: {
    fontWeight: 'bold',
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1),
  },
  checkInRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  checkInTime: {
    paddingLeft: theme.spacing(1),
  },
  suppressClickable: {
    pointerEvents: 'none',
  },
}));
